import { Directive, HostListener, Output, EventEmitter } from '@angular/core';


@Directive({ selector: '[onEnterPress]' })
export class OnEnterPressDirective {
    @Output('onEnterPress') onEnterPress:EventEmitter<void> = new EventEmitter<void>();
    
    @HostListener('keypress', ['$event']) onChange(event) {
        if (event.keyCode === 13) {
            this.onEnterPress.emit();
        }
    }

}


// WEBPACK FOOTER //
// ./web/static/services/directives/OnEnterPress.ts